import React from 'react'
import {
  TopSuperadmin,
  Kebijakan,
  Inisiatif,
  OrganizationSuperadmin,
  Kasus,
} from '.'
import { FormRow } from '../../../components'

const MainContentSuperadmin = () => {
  return (
    <div>
      <FormRow>
        <TopSuperadmin/>
      </FormRow>
      <div className="flex flex-wrap -mx-4 mb-5 md:mb-8">
        <div className="w-full md:w-1/2 px-4 mb-5 md:mb-0">
          <Kebijakan />
        </div>
        <div className="w-full md:w-1/2 px-4">
          <Inisiatif />
        </div>
      </div>
      <div className="flex flex-wrap -mx-4 mb-5 md:mb-8 xl:mb-0">
        <div className="w-full md:w-1/2 px-4 mb-5 md:mb-0">
          <OrganizationSuperadmin />
        </div>
        <div className="w-full md:w-1/2 px-4">
          <Kasus />
        </div>
      </div>
    </div>
  )
}

export { MainContentSuperadmin }
